
    <h3><a routerLink="/mailing/tasks/show">Задания</a> -></h3>
    <app-display-mailing-task [task]="task"></app-display-mailing-task>
  